<template>
    <el-dialog title="每日最优煤源配置" :visible="visible" :show="show" width="40%"     :close-on-click-modal="false"
               @close="close" custom-class="module-dialog">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="150px">
            <!--<el-form-item label="目标到场地" class="input" prop="arrtiveStation">
                <el-input v-model="ruleForm.arrtiveStation" autocomplete="off"
                                 placeholder="请输入目标到场地" ></el-input>
            </el-form-item>-->
            <el-form-item label="目标热值" class="input" prop="targetHots">
                <el-input v-model.number="ruleForm.targetHots" autocomplete="off"
                          placeholder="请输入目标热值" ></el-input>
            </el-form-item>
            <el-form-item label="目标硫分" class="input" prop="targetLiufen">
                <el-input-number :controls="false" :step="0.1" v-model="ruleForm.targetLiufen"  autocomplete="off"
                                 placeholder="请输入目标硫分" style="width:100%" ></el-input-number>
            </el-form-item>
            <el-form-item label="目标吨数" class="input" prop="totalCount">
                <el-input-number :controls="false"  v-model="ruleForm.totalCount"  autocomplete="off"
                                 placeholder="请输入目标吨数" style="width:100%" ></el-input-number>
            </el-form-item>
            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary" v-show="updateBtn" @click="commit()">保存</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'addOrUpdate',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                }
            },
            rowData(){
                this.ruleForm = this.rowData;
                if (this.rowData.type=='info'){
                    this.updateBtn = false;
                }
            },
        },
        data(){
            var validateNumber = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入数字'));
                }
                setTimeout(() => {
                    if (!Number.isNaN(value) && /^-?\d+(\.\d+)?$/.test(value)) {
                        callback();
                    } else {
                        callback(new Error('请输入有效的数字或小数'));
                    }
                }, 100);
            };
            var validateTotalCount = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入数字'));
                }
                setTimeout(() => {
                    if (!Number.isNaN(value) && value%100==0) {
                        callback();
                    } else {
                        callback(new Error('请输入100的倍数'));
                    }
                }, 100);
            };
            return{
                updateBtn:true,
                url:base.get().url,
                visible:false,
                ruleForm:{
                    targetHots:'',
                    targetLiufen:'',
                    arrtiveStation:'',
                    totalCount:'',
                },
                rules:{
//                    arrtiveStation:[{ required: true, message: '请输入到达到场地', trigger: 'blur' }],
                    targetLiufen:[{ required: true, message: '请输入目标硫分', trigger: 'blur' },
                        {validator:validateNumber,trigger:'blur'}
                    ],
                    targetHots:[{ required: true, message: '请输入目标热值', trigger: 'blur' },
                        {validator:validateNumber,trigger:'blur'}
                    ],
                    totalCount:[{ required: true, message: '请输入吨数', trigger: 'blur' },
                        {validator:validateTotalCount,trigger:'blur'}
                    ],
                },
            }
        },
        methods:{
            close(){
                this.updateBtn = true;
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
            },
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url:  this.ruleForm.id==''|| this.ruleForm.id==undefined?this.url+`bestCocalMatchConfig/`+"save":this.url+`bestCocalMatchConfig/`+"update",
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: "保存成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },

        }
    }
</script>
<style lang="scss">
    .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }

    .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
    }

    .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }

    .detail-form-content .el-form-item {
        margin-bottom: 20px;
    }

    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
        font-size: 14px;
    }

    .detail-form-content .el-form-item__content {
        line-height: normal;
    }

    .detail-form-content .el-input__inner {
        border-radius: 4px;
        border-color: #dcdfe6;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-input__inner:focus {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-select {
        width: 100%;
    }

    .detail-form-content .el-upload-list--picture-card .el-upload-list__item,
    .detail-form-content .el-upload--picture-card {
        width: 120px;
        height: 120px;
        line-height: 126px;
        border-radius: 6px;
        border: 1px dashed #c0ccda;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-upload--picture-card:hover {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-upload--picture-card i {
        font-size: 28px;
        color: #8c939d;
    }

    .detail-form-content .el-upload--picture-card:hover i {
        color: var(--publicMainColor);
    }

    .detail-form-content .el-input.is-disabled .el-input__inner {
        background-color: #f5f7fa;
        color: #909399;
        cursor: not-allowed;
    }

    .detail-form-content .form-footer {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding-top: 16px;
        border-top: 1px solid #f0f0f0;
        margin-top: 8px;
    }

    .detail-form-content .form-footer .el-button {
        min-width: 100px;
        border-radius: 4px;
    }

    .detail-form-content .form-footer .el-button--primary {
        background-color: var(--publicMainColor);
        border-color: var(--publicMainColor);
    }

    .detail-form-content .form-footer .el-button--primary:hover {
        background-color: #2b5797;
        border-color: #2b5797;
    }

    .detail-form-content .form-footer .el-button--default:hover {
        color: var(--publicMainColor);
        border-color: rgba(58, 110, 165, 0.3);
        background-color: rgba(58, 110, 165, 0.06);
    }
</style>